import { render } from "./DsTextarea.vue?vue&type=template&id=a6d95e42&scoped=true"
import script from "./DsTextarea.vue?vue&type=script&lang=js"
export * from "./DsTextarea.vue?vue&type=script&lang=js"

import "./DsTextarea.vue?vue&type=style&index=0&id=a6d95e42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d95e42"]])

export default __exports__